import { useState } from "react";
import { Questions } from "../utils/constants";
import { ChevronDownIcon } from "@heroicons/react/24/solid";

export default function QuestionAndAnswers() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <div className="w-full mx-auto">
      {Questions.map((q, i) => (
        <div key={i} className="border mt-2  rounded-2xl border-gray-50 shadow-xl">
          <button onClick={() => toggle(i)} className="bg-[#FFE3D7] cursor-pointer w-full  text-start px-5 py-4 flex justify-between items-center">
            <span className="font-family-vazirmatn font-bold text-lg">{q.question}</span>

            <ChevronDownIcon
              className={`
                w-6 h-6 text-gray-600 transition-transform duration-300
                ${openIndex === i ? "rotate-180" : "rotate-0"}
              `}
            />
          </button>
          {/* Answer */}
          <div
            className={`
              bg-[#FFF3ED]
              px-5 overflow-hidden transition-all duration-200 ease-initial
              ${openIndex === i ? "max-h-40 py-2" : "max-h-0 py-0"}
            `}
          >
            <p className="text-gray-600 font-family-vazirmatn leading-7">{q.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
